import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=0d326b58&scoped=true"
import script from "./Tel.vue?vue&type=script&lang=js"
export * from "./Tel.vue?vue&type=script&lang=js"
import style0 from "./Tel.vue?vue&type=style&index=0&id=0d326b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d326b58",
  null
  
)

export default component.exports